import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { removeDefaultParams } from '../../Utils/helper';
import { AnchorTagUrl, Heading, UrlsEachinks, UrlsLinks } from './styled';

function SitemapUrls(props) {
  const { heading, data, onlyLastname } = props;

  const router = useRouter();
  const getTitle = (title) => {
    if (onlyLastname) {
      const title_split = title.split('/');
      let titleName = null;
      if (title_split?.length > 0) {
        titleName = title_split?.[title_split?.length - 1];
      }
      const final_title = titleName.split('-').join(' ');
      return final_title;
    } else {
      const title_split = title.split('-');
      let string_length_consider = '';
      const title_split_copy = [...title_split];
      if (isNaN(title_split_copy.pop())) {
        string_length_consider = title_split.length;
      } else {
        string_length_consider =
          title_split.length > 1 ? title_split.length - 1 : title_split.length;
      }
      const title_removed_id = title_split.slice(0, string_length_consider);
      const title_removed_hyphen = title_removed_id.join(' ');
      const final_title = title_removed_hyphen.split('/').join(' ');
      return final_title;
    }
  };

  return (
    <>
      <Heading> {heading}-:</Heading>
      <UrlsLinks>
        {data.map((url, index) => {
          return (
            (url.web_url || url.webUrl) && (
              <Link
                href={{
                  pathname: url.web_url || url.webUrl,
                  query: removeDefaultParams(router.query),
                }}
                passHref
                locale={false}
                legacyBehavior
              >
                <AnchorTagUrl>
                  <UrlsEachinks key={url + '-' + index}>
                    {getTitle(url.web_url || url.webUrl)}
                  </UrlsEachinks>
                  <div className="seperator"> | &nbsp;</div>
                </AnchorTagUrl>
              </Link>
            )
          );
        })}
      </UrlsLinks>
    </>
  );
}

export default SitemapUrls;
